import { inject, Injectable } from '@angular/core';
import { CustomDashboardComponent } from '@observation/shared/components/custom-dashboard/custom-dashboard.component';
import { Tile } from '@shared/models';
import { FilterAnalytic } from '../models/analytic.model';
import { UsageTrackingServiceInterface } from '../models/usage-tracking-service.interface';
import { FilterTrackingService } from './filter-tracking.service';
import { TrackingService } from './tracking.service';

@Injectable({ providedIn: 'root' })
export class CustomChartFilterService
  extends FilterTrackingService
  implements UsageTrackingServiceInterface
{
  private readonly trackingService = inject(TrackingService);

  public addUsageTracking(
    element: CustomDashboardComponent,
    args: [{ name: string }, Tile]
  ): void {
    const filterAnalytic: FilterAnalytic = this.getFilterAnalytic(
      args[1]?.allowedSelects.find(allowed => allowed.currentActive)
        .dimensionId,
      args[0].name,
      element.dimensionNames
    );

    this.trackingService.addUsageTracking(filterAnalytic);
  }
}
